if (!customElements.get('kiwi-click-image-tabs')) {
  class KiwiClickImageTabs extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;

      this.items = Array.from(this.querySelectorAll('[data-kiwi-click-tab]'));
      this.slides = Array.from(this.querySelectorAll('[data-kiwi-click-slide]'));
      this.dots = Array.from(this.querySelectorAll('[data-kiwi-click-dot]'));
      this.prevButton = this.querySelector('[data-kiwi-click-prev]');
      this.nextButton = this.querySelector('[data-kiwi-click-next]');
      const initialIndex = Math.max(0, this.items.findIndex((item) => item.classList.contains('is-active')));
      this.activeIndex = -1;
      this.initialized = true;

      this.handleItemClick = this.handleItemClick.bind(this);
      this.handleItemKeydown = this.handleItemKeydown.bind(this);
      this.handleBlockSelect = this.handleBlockSelect.bind(this);
      this.handlePrevClick = this.handlePrevClick.bind(this);
      this.handleNextClick = this.handleNextClick.bind(this);

      this.items.forEach((item) => item.addEventListener('click', this.handleItemClick));
      this.items.forEach((item) => item.addEventListener('keydown', this.handleItemKeydown));
      this.prevButton?.addEventListener('click', this.handlePrevClick);
      this.nextButton?.addEventListener('click', this.handleNextClick);
      document.addEventListener('shopify:block:select', this.handleBlockSelect);
      this.goTo(initialIndex);
    }

    disconnectedCallback() {
      this.items.forEach((item) => item.removeEventListener('click', this.handleItemClick));
      this.items.forEach((item) => item.removeEventListener('keydown', this.handleItemKeydown));
      this.prevButton?.removeEventListener('click', this.handlePrevClick);
      this.nextButton?.removeEventListener('click', this.handleNextClick);
      document.removeEventListener('shopify:block:select', this.handleBlockSelect);
    }

    handleItemClick(event) {
      const index = Number.parseInt(event.currentTarget.dataset.index, 10);
      if (Number.isNaN(index)) return;
      this.goTo(index);
    }

    handlePrevClick() {
      this.goTo(this.activeIndex - 1);
    }

    handleNextClick() {
      this.goTo(this.activeIndex + 1);
    }

    handleItemKeydown(event) {
      if (event.key !== 'Enter' && event.key !== ' ') return;

      event.preventDefault();
      const index = Number.parseInt(event.currentTarget.dataset.index, 10);
      if (Number.isNaN(index)) return;
      this.goTo(index);
    }

    handleBlockSelect(event) {
      const item = event.target?.closest?.('[data-kiwi-click-tab]');
      if (!item || !this.contains(item)) return;

      const index = Number.parseInt(item.dataset.index, 10);
      if (Number.isNaN(index)) return;
      this.goTo(index);
    }

    goTo(index) {
      if (!this.items.length || !this.slides.length) return;

      const normalizedIndex = ((index % this.items.length) + this.items.length) % this.items.length;
      if (normalizedIndex === this.activeIndex) return;
      this.activeIndex = normalizedIndex;

      this.items.forEach((item, itemIndex) => {
        const isActive = itemIndex === normalizedIndex;
        item.classList.toggle('is-active', isActive);
        item.setAttribute('aria-selected', isActive ? 'true' : 'false');
        item.tabIndex = isActive ? 0 : -1;
      });

      this.slides.forEach((slide, slideIndex) => {
        const isActive = slideIndex === normalizedIndex;
        slide.classList.toggle('is-active', isActive);
        slide.setAttribute('aria-hidden', isActive ? 'false' : 'true');
      });

      this.dots.forEach((dot, dotIndex) => {
        dot.classList.toggle('is-active', dotIndex === normalizedIndex);
      });

    }
  }

  customElements.define('kiwi-click-image-tabs', KiwiClickImageTabs);
}
